<!-- @format -->

<agreement-tag>
<style>
.alert {
  color:red;
}
</style>

  <div class="contents">
    
    <section class="contents_area">
      <div class="contents_block detail" style="text-align:center">

      <img src="/assets/img/logo.svg" style="width:300px" />

          <div class="container_news-title" style="margin-top: 32px">ご利用規約</div><!--/.container_news-title-->
          
          <div style="text-align:center; width: 100%">
            <div if={state.now_date <= 20220331} class="contents_block detail" style="padding: 1em ;margin: 0 auto; text-align: left;width:70%;height:300px; overflow-y: scroll; border: 1px solid #000">
              <rules-content-tag></rules-content-tag>
            </div>
              <div if={state.now_date >= 20220401} class="contents_block detail" style="padding: 1em ;margin: 0 auto; text-align: left;width:70%;height:300px; overflow-y: scroll; border: 1px solid #000">
                  <rules-content-tag20220401></rules-content-tag20220401>
              </div>
          </div>

  <div style="margin-top: 20px;">
								<input type="checkbox" value="agree" name="rules" id="rules" class="checkbox-input">
								<label for="rules" class="checkbox-parts">規約に同意します</label>
  </div>
  <div style="margin-top: 10px;">

								<input type="checkbox" value="agree" name="privacy" id="privacy" class="checkbox-input">
								<label for="privacy" class="checkbox-parts">「<a href="https://cro-co.co.jp/privacypolicy/agreement/" target="_blank">個人情報の取り扱い</a>」に同意します</label>



  </div>


        <div class="box_flex03 margin-spacing-3_top">
          <div class="button button-secondary-large" type="button" value="登録する" data-target=""  onclick={(e)=>register(e)}>登録する</div>
        </div>
      </div><!--/.contents_block-->

    </section><!--/.contents_area-->
    
  </div><!--/.contents-->

<script>
  import di from "dependency-injection";
  import rulesTag from '@tags/parts/edilent-worker-rules.riot';
  import rulesTag20220401after from '@tags/parts/edilent-worker-rules20220401after.riot';
  export default {
    components: {
      "rules-content-tag": rulesTag,
      "rules-content-tag20220401": rulesTag20220401after,
    },
    state:{
      now_date : null,
    },
    register(e) {
      const params = {
        rules: false,
        privacy: false
      };
      this.$$('div.alert').forEach((e)=> e.remove());
      this.$$('input[type=checkbox]:checked').forEach((e)=>{
        params[e.getAttribute('name')] = e.value;
      });
      Object.keys(params).forEach((name)=>{
        if (!params[name]) {
          const element = this.$(`input[name=${name}]`);
          const parent = element.parentElement;
          const div = document.createElement('div');
          div.textContent = '同意頂いていません';
          div.classList.add('alert');
          parent.appendChild(div);
        }
      });

      const alertsNum = this.$$('div.alert').length;
      if (alertsNum === 0) {
        this.Api.request('agreement', 'execute', params)
          .then(data => {
            if ((location.search || '').match(/r=([^&]+)/)) {
              location.href = RegExp.$1;
            } else {
              di.router.push('/menu');
            }
          })
          .catch(err => {
            alert(err);
          })
      }
    },
    onBeforeMount(props){
      this.Api = di.createApi('register');

      let date = new Date();
      let month = (date.getMonth() + 1 <= 9) ? "0" + (date.getMonth() + 1).toString() : date.getMonth().toString();
      let day = (date.getDate()  <= 9) ? "0" + (date.getDate()).toString() : date.getDate().toString();
      this.state.now_date = parseInt( date.getFullYear() + month + day );
    }
  }
</script>
</agreement-tag>
